import React, { useEffect, useState } from "react";
import { BOOKING_FORM, JOB_FORM } from "./ERP";
import { bookingsStore, configStore } from "../state/CommonState";
import { visibilityStore } from "../trackmybookings/visibilityStore";
import Utils from "../util/Utils";
import Taskapi from "../mytasks/tasks-api";
import VisibilityApi from "../state/Visibility-api";
import { taskStore } from "../mytasks/task-store";

export default function LoadErp(props) {
    const [formData, setFormData] = useState({});
    const [erpStatus, setErpStatus] = useState(null);
    const formType = props.type
    const booking = bookingsStore.current

    const shipmentMovement = Utils.fetchBookingType(bookingsStore.current).toUpperCase()

    useEffect(() => {
        const fetchData = async () => {
            try {
                booking.shipmentMovement = shipmentMovement;

                const response = await Taskapi.getbookingdsr(booking._id);

                const bookingDsr = response?.[0] || null;

                setFormData(formType === 'job' ? JOB_FORM(booking, bookingDsr) : BOOKING_FORM(booking, bookingDsr));
            } catch (error) {
                console.error("Error fetching booking DSR:", error);
            }
        };

        fetchData();
    }, [booking, formType, shipmentMovement]);

    // useEffect(() => {
    //     const fetchBookingStatus = async () => {
    //         try {
    //             const response = await VisibilityApi.getBookingStatus(booking._id);
    //             setErpStatus(response?.status || "Unknown Status");
    //         } catch (error) {
    //             console.error("Error fetching booking status:", error);
    //             setErpStatus("Error fetching status");
    //         }
    //     };

    //     fetchBookingStatus();
    // }, [booking]);



    const handleChange = (e, path) => {
        const { name, value } = e.target;
        setFormData((prevState) => {
            const updatedData = { ...prevState };
            let ref = updatedData;

            const keys = path.split(".");
            for (let i = 0; i < keys.length - 1; i++) {
                ref = ref[keys[i]];
            }
            ref[keys[keys.length - 1]] = value;
            return { ...updatedData };
        });
    };


    const handleAddItem = (path) => {
        setFormData((prevState) => {
            const updatedData = { ...prevState };
            let ref = updatedData;

    
            const keys = path.split(".");
            for (let i = 0; i < keys.length - 1; i++) {
                ref = ref[keys[i]];
            }

          
            ref[keys[keys.length - 1]].push(
                Object.fromEntries(Object.keys(ref[keys[keys.length - 1]][0]).map((key) => [key, ""]))
            );

            return { ...updatedData };
        });
    };

    const renderFormFields = (data, path = "") => {
        return Object.keys(data).map((key) => {
            const fieldPath = path ? `${path}.${key}` : key;
            const value = data[key];
    
            if (Array.isArray(value)) {
                return (
                    <div key={fieldPath} className="mb-6">
                        <h3 className="text-md font-semibold mb-2">{key.replace(/([A-Z])/g, " $1").trim()}:</h3>
                        {value.map((item, index) => (
                            <div key={`${fieldPath}[${index}]`} className="p-3 border rounded mb-3">
                                <h4 className="text-sm font-medium mb-2">Item {index + 1}</h4>
                                <div className="flex flex-wrap gap-4">
                                    {renderFormFields(item, `${fieldPath}.${index}`)}
                                </div>
                            </div>
                        ))}
                        {key !== 'HBL' && (
                            <button
                                type="button"
                                onClick={() => handleAddItem(fieldPath)}
                                className="button is-info mt-1"
                            >
                                + Add {key.replace(/([A-Z])/g, " $1")}
                            </button>
                        )}
                    </div>
                );
            }
            

            if (typeof value === "object" && value !== null) {
                return (
                    <div key={fieldPath} className="mb-6">
                        <h3 className="text-md font-semibold mb-2">{key.replace(/([A-Z])/g, " $1").trim()}:</h3>
                        <div className="flex flex-wrap gap-4">
                            {renderFormFields(value, fieldPath)}
                        </div>
                    </div>
                );
            }
    

            return (
                <div key={fieldPath} className="flex flex-col w-64">
                    <label className="text-sm font-medium mb-1">{key.replace(/([A-Z])/g, " $1").trim()}:</label>
                    <input
                        type="text"
                        name={key}
                        value={value}
                        onChange={(e) => handleChange(e, fieldPath)}
                        className="p-2 border rounded"
                    />
                </div>
            );
        });
    };
    

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        try {
            const res = await VisibilityApi.createErp({ creationOf: formType, data: formData });

            configStore.setModalMessage(res.message);
        } catch (err) {
            console.error("Error in handleSubmit:", err);
            configStore.setModalMessage(err.message || "An error occurred");
        }
    };


    return (
        <div className="flex flex-col p-4 gap-6">
            <div className="w-full flex justify-end">
                <button className="button is-small islink"
                    onClick={() => {
                        taskStore.loadERP = false;
                    }}>
                    <span className="icon">
                        <i className="fas fa-xmark"></i>
                    </span>
                </button>
            </div>
            <div className="w-full p-4 border rounded shadow-md">
                <h2 className="text-lg font-bold mb-4">
                    {booking.contract.shipmentType.substr(0, 3) + ' ' + shipmentMovement} {formType} form
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {renderFormFields(formData)}
                </form>
            </div>
    
            {/* JSON Preview Section + Submit Button */}
            <div className="w-full p-4 border rounded shadow-md bg-gray-100">
                <h2 className="text-lg font-bold mb-2">Form Data Preview</h2>
                <pre className="p-2 text-xs overflow-auto max-h-64 bg-white border rounded">{JSON.stringify(formData, null, 2)}</pre>
                <button
                    type="button"
                    className="button is-success mt-3"
                    onClick={() => document.querySelector("form").requestSubmit()}
                >
                    Submit {formType}
                </button>
            </div>
        </div>
    );
    
}